import styled from 'styled-components'

interface IBudgetCategoryCardHeaderStyledProps {}

export const BudgetCategoryCardHeaderStyled = styled.div<IBudgetCategoryCardHeaderStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
